import type { LinkEditor } from "Core/Screens/Common/LinkEditor/LinkEditor";
import { controlFacade } from "./ControlFacade";
import { tabGridFacade } from "Core/Components/CustomFunctions/Facades/TabGridFacade";

export interface IRelationType {
    id: number;
    name: string;
    typeName: string;
    enabled: boolean;
}

export const linkEditorFacade = (screen: LinkEditor)=> {

    const getControlByFieldName = (fieldName: string) => {

        let control = _.find(screen.GetAllControls(), (c) => c.GetFieldModel() && c.GetFieldModel().Name === fieldName);
        if(control){
            return controlFacade(control);
        }
        return null;
    }

    const getControls = () => {
        return [
            ..._.map(screen.GetAllControls(), (control)=> controlFacade(control)),
            ..._.map(screen.GetTabTables()?.Data || [], (tabTable) => tabGridFacade(tabTable))
         ]
    }

    /**
     * Get the currently selected relation type ID
     */
    const getRelationTypeId = (): number => {
        return screen.RelationTypeId;
    }

    /**
     * Get all available relation types
     */
    const getRelationTypes = (): IRelationType[] => {
        const relationTypes = (screen as any)._relationTypes || [];
        return relationTypes.map((rt: any) => ({
            id: rt.RecordId,
            name: rt.Name,
            typeName: rt.TypeName,
            enabled: rt.Enabled && rt.IsRecordEnabled
        }));
    }

    /**
     * Get the currently selected relation type object
     */
    const getSelectedRelationType = (): IRelationType | null => {
        const relationTypeId = getRelationTypeId();
        if (!relationTypeId) return null;

        const relationTypes = getRelationTypes();
        return relationTypes.find(rt => rt.id === +relationTypeId) || null;
    }

    /**
     * Check if the selected relation type matches a given name
     * @param name - The relation type name to check (e.g., 'Process articles', 'Factur')
     */
    const isRelationType = (name: string): boolean => {
        const selected = getSelectedRelationType();
        return selected?.name === name;
    }

    /**
     * Subscribe to relation type changes
     * @param callback - Function to call when relation type changes
     */
    const onRelationTypeChanged = (callback: (relationTypeId: number) => void): void => {
        const observable = (screen as any)._selectedRelationTypeId;
        if (observable && observable.subscribe) {
            observable.subscribe((newValue: number) => callback(newValue));
        }
    }

    return {
        getControlByFieldName,
        getControls,
        // Relation type methods
        getRelationTypeId,
        getRelationTypes,
        getSelectedRelationType,
        isRelationType,
        onRelationTypeChanged
    }
}